import React from "react";

const PreorderContext = React.createContext(null);

export default PreorderContext;
